import React from 'react';

export default function StudentPortalBanner({ settings }) {
  if (!settings?.bannerEnabled || !settings?.bannerText?.trim()) return null;
  const speed = Math.max(6, Number(settings.bannerSpeed) || 18);
  return (
    <div
      className="sp-marquee"
      role="region"
      aria-label="Student portal announcement"
      style={{
        background: settings.bannerBackground || '#111827',
        color: settings.bannerTextColor || '#ffffff',
        '--sp-marquee-duration': `${speed}s`
      }}
    >
      <div className="sp-marquee-track">
        <span className="sp-marquee-text">{settings.bannerText}</span>
        <span className="sp-marquee-text" aria-hidden="true">{settings.bannerText}</span>
      </div>
    </div>
  );
}

